module.exports = __webpack_public_path__ + "static/media/squared.bcdd6918.jpg";